module.exports = __webpack_public_path__ + "img/tel.bae5c257.png";